// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import environment from '../../environment';

type Props = {
  defaultZoom?: number;
  zoom?: number;
  center: string;
  width: number;
  height: number;
  marker?: string;
  className?: string;
};

const BASE_STATIC_MAP_URL = 'https://maps.googleapis.com/maps/api/staticmap';

const StaticMap = (props: Props) => {
  const { defaultZoom, zoom, center, width, height, className, marker } = props;
  const z = center ? zoom : defaultZoom;
  let src = BASE_STATIC_MAP_URL +
    `?${z ? `&zoom=${z}` : ''}&center=${center}&size=${width}x${height}&maptype=roadmap&key=${environment.googleMaps}`;
  if (marker) {
    src += `&markers=size:mid%7Ccolor:0xff0000%7Clabel:%7C${marker}`;
  }
  return (
    <img className={className} src={src} alt={center}/>
  );
};

StaticMap.propTypes = {
  defaultZoom: PropTypes.number,
  zoom: PropTypes.number,
  center: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  marker: PropTypes.string,
  className: PropTypes.string,
};

export default StaticMap;



// WEBPACK FOOTER //
// ./src/elements/Map/StaticMap.jsx